import { InputBuildProps } from 'components/molecules/InputBuild/interfaces';
import { SelectBuildProps } from 'components/molecules/SelectBuild/interfaces';

export const formFilterHistory: {
   input?: InputBuildProps
   select?: SelectBuildProps
   layout?: any
}[] = [
      {
         input: {
            id: 'dataInicio',
            label: 'Data Início:',
            type: 'date'
         },
         layout: {
            type: 'col',
            layout: { base: 12, md: 3 }
         }
      },
      {
         input: {
            id: 'dataFim',
            label: 'Data Fim:',
            type: 'date'
         },
         layout: {
            type: 'col',
            layout: { base: 12, md: 3 }
         }
      },
      {
         select: {
            id: 'uf',
            label: 'UF:',
            optionsType: 'ufSearchContract',
         },
         layout: {
            type: 'col',
            layout: { base: 12, md: 3 }
         }
      },
      {
         input: {
            id: 'chassi',
            label: 'Chassi:',
            type: 'text'
         },
         layout: {
            type: 'col',
            layout: { base: 12, md: 3 }
         }
      },
      {
         input: {
            id: 'numeroContrato',
            label: 'Nº do Contrato:',
            type: 'text'
         },
         layout: {
            type: 'col',
            layout: { base: 12, md: 3 }
         }
      },
      {
         input: {
            id: 'usuario',
            label: 'Usuário:',
            type: 'text'
         },
         layout: {
            type: 'col',
            layout: { base: 12, md: 3 }
         }
      }
   ];